export enum DateOfSaleOrServiceRule {
  SameAsInvoiceDate = 'SAME_AS_INVOICE_DATE',
}
